import { useState, useEffect, useCallback, useRef } from 'react';
import { useMorningDashboard } from '@morning-dashboard/context/MorningDashoardContext';

function formatElapsed(minutes: number): string {
  if (minutes === 0) return 'Refreshed a few seconds ago';
  if (minutes < 60) return `Refreshed ${minutes} ${minutes === 1 ? 'minute' : 'minutes'} ago`;
  return `Refreshed ${Math.floor(minutes / 60)} ${Math.floor(minutes / 60) === 1 ? 'hour' : 'hours'} ago`;
}

export const useRefreshCounter = () => {
  const { isCustomizeOpened, setIsCustomizeOpened, confirmOrder, revertOrder, triggerRefresh } = useMorningDashboard();
  const [elapsed, setElapsed] = useState(0);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const startTimer = useCallback(() => {
    setElapsed(0);
    if (intervalRef.current) clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => setElapsed((prev) => prev + 1), 60000);
  }, []);

  useEffect(() => {
    startTimer();
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [startTimer]);

  const handleRefresh = useCallback(() => {
    startTimer();
    triggerRefresh();
  }, [startTimer, triggerRefresh]);

  return {
    elapsedLabel: formatElapsed(elapsed),
    handleRefresh,
    isCustomizeOpened,
    setIsCustomizeOpened,
    confirmOrder,
    revertOrder,
  };
};
